import React, { Component } from 'react'
import '../../card.css'

class Card extends Component {

    constructor(props){
        super(props)
    }

    render() {
        return (
            <div onClick={() => this.props.openImage(false)} class="card-outer-container result-card-outer-container">
                <div class="card-inner-container">
                    <div class="card-image-container">
                        <img class="card-image" src={this.props.image} />
                    </div>
                    <div class="card-text-container">
                        <p class="card-text">{this.props.name}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Card